import "./ServiceRequest.css";
import { getTranslatedText as translate } from "../../Localization/Translation";
import useServices from "./useServices";

const ServiceRequest = () => {
  const {
    selectItemType,
    selectServiceTypes,
    changeNumber,
    plusButton,
    deleteRowServe,
    locale,
    setServiceRequestCity,
    serviceRequestCity,
    serviceRequestBuilding,
    setServiceRequestBuilding,
    serviceRequestFloor,
    setServiceRequestFloor,
    serviceTypesSelect,
    newItemType,
    newServiceTypes,
    newPrice,
    totalPrice,
    priceAfterDiscount,
    newDetailedOrder,
    TakeAndGiveCheckbox,
    setTakeAndGiveCheckbox,
    AllCities,
    Laundry,
  } = useServices();

  return (
    <div className="service-request-component">
      <div className="mb-4 name-section-request-service" dir="auto">
        <span>{translate("Laundry-name-label-order", locale)}</span>
        <span>{Laundry.name}</span>
      </div>

      {/* LOCATION SELECT */}
      <div className="mb-5">
        <div
          className="form-row location-row-request-service mb-1 row"
          dir="auto"
        >
          <label
            htmlFor="InputLocationSettings"
            className="form-label col-md-3"
          >
            {translate("specify-current-location", locale)}
          </label>

          <div
            className="col row gap-3"
            style={{ marginLeft: "2px", marginRight: "2px" }}
          >
            {/* All Cities Dropdown */}
            <div className="form-group col-md-3">
              <select
                id="inputState"
                className="form-control"
                defaultValue={serviceRequestCity}
                onChange={(event) => setServiceRequestCity(event.target.value)}
              >
                <option value="choose-city">
                  {translate("choose-city", locale)}
                </option>
                {AllCities.map((city) => {
                  return (
                    <option key={city.id} value={city.name}>
                      {city.name}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* Building number */}
            <div className="form-group col-md-3">
              <input
                type="number"
                className="form-control"
                id="inputCity"
                defaultValue={serviceRequestBuilding}
                placeholder={translate("building-number", locale)}
                onChange={(event) =>
                  setServiceRequestBuilding(event.target.value)
                }
              />
            </div>
            {/* Floor number */}
            <div className="form-group col-md-3">
              <input
                type="number"
                className="form-control"
                id="inputZip"
                defaultValue={serviceRequestFloor}
                placeholder={translate("floor-number", locale)}
                onChange={(event) => setServiceRequestFloor(event.target.value)}
              />
            </div>
          </div>
        </div>
        <span className="span-under-location-row">
          {translate("span-under-location-row", locale)}
        </span>
      </div>

      {/* TABLE */}
      <div className="table-container-notification mb-4">
        <table className="table" dir="auto">
          <thead className="thead-dark">
            <tr className="table-notification-details-header">
              <th scope="col">#</th>
              <th scope="col">{translate("item-type-column", locale)}</th>
              <th scope="col">{translate("service-type-column", locale)}</th>
              <th scope="col">{translate("number-of-items-column", locale)}</th>
              <th scope="col">{translate("price-column", locale)}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {newDetailedOrder.map((detail, index) => {
              return (
                <tr key={detail.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{detail.itemType}</td>
                  <td>
                    {detail.serviceTypes.map((type, indexType) => {
                      if (indexType !== detail.serviceTypes.length - 1)
                        return type + " - ";
                      else return type;
                    })}
                  </td>
                  <td>{detail.numberOfItems}</td>
                  <td>{detail.price}</td>
                  <td
                    className="delete-row-serv"
                    onClick={() => deleteRowServe(detail.id)}
                  >
                    {translate("cancel-btn", locale)}
                  </td>
                </tr>
              );
            })}

            {/* Add Service row */}
            <tr className="add-service-request-row">
              <th onClick={plusButton}>
                <span className="add-service-row-icon">
                  <i className="bi bi-plus-square-fill"></i>
                </span>
              </th>
              <td className="table-td">
                {/* ITEM TYPE SELECT */}
                <select
                  className="drop-down-select-req clean"
                  onChange={selectItemType}
                  name="itemType"
                >
                  <option className="optionsMenu" value="">
                    {translate("choose-type", locale)}
                  </option>
                  {Laundry.services.map((service, index) => {
                    return (
                      <option
                        className="optionsMenu"
                        key={service.serviceId}
                        value={index}
                      >
                        {service.itemType}
                      </option>
                    );
                  })}
                </select>
              </td>

              <td className="table-td">
                <p style={{ width: "100px", margin: 0 }}>
                  {newServiceTypes.map((type, indexType) => {
                    if (indexType !== newServiceTypes.length - 1)
                      return type + " - ";
                    else return type;
                  })}
                </p>

                {/* SERVICE TYPES SELECT */}
                <select
                  className="drop-down-select-req clean"
                  onChange={selectServiceTypes}
                  name="serviceTypes"
                  disabled={serviceTypesSelect.length ? false : true}
                >
                  {serviceTypesSelect.length ? (
                    <>
                      <option className="optionsMenu" value="">
                        {translate("choose=service-type-select-option", locale)}
                      </option>
                      {serviceTypesSelect.map((serviceOnItem, index) => {
                        return (
                          <option
                            className="optionsMenu"
                            key={serviceOnItem.serviceOnItemId}
                            value={serviceOnItem.serviceOnItemId}
                          >
                            {"(" +
                              serviceOnItem.serviceName +
                              ", " +
                              serviceOnItem.servicePrice +
                              ")"}
                          </option>
                        );
                      })}
                    </>
                  ) : newItemType === "" ? (
                    <option
                      className="optionsMenu"
                      value="اختر نوع القطعة أولاً"
                    >
                      {translate("choose-type-first", locale)}
                    </option>
                  ) : (
                    <option className="optionsMenu" value="no-services-yet">
                      {translate("no-services-yet", locale)}
                    </option>
                  )}
                </select>
              </td>

              {/* NUMBER OF ITEMS */}
              <td className="table-td table-td-number-of-items">
                <input
                  type="number"
                  min="1"
                  className="service-request-input-number clean"
                  onChange={changeNumber}
                />
              </td>
              <td>
                <span>{newPrice}</span>
              </td>
              <td className="delete-row-serv">
                <span></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="mb-3 form-check"
        dir="auto"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <input
          type="checkbox"
          className="form-check"
          id="autoLocationSettings"
          defaultChecked={TakeAndGiveCheckbox}
          onClick={() => {
            setTakeAndGiveCheckbox(!TakeAndGiveCheckbox);
          }}
        />
        <label className="form-check-label" htmlFor="autoLocationSettings">
          {translate("check-box-take-your-order", locale)}
        </label>
      </div>
      <div className="mb-3 name-section-request-service row" dir="auto">
        <div className="col-md">
          <span>{translate("price-label-modal", locale)}</span>
          <span>
            {totalPrice}
            {" " + translate("currency", locale)}
          </span>
        </div>
        {Laundry.discount || Laundry.freeDelivery ? (
          <div className="service-offer-price col-md">
            {Laundry.discount ? (
              <div className="offer-item">
                <span>{translate("price-after-discount", locale)}</span>
                <span>
                  {priceAfterDiscount}
                  {" " + translate("currency", locale)}
                </span>
              </div>
            ) : (
              <></>
            )}
            {Laundry.freeDelivery ? (
              <div className="offer-item">
                <span>{translate("price-after-free-delivery", locale)}</span>
                <span>
                  {priceAfterDiscount}
                  {" " + translate("currency", locale)}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
export default ServiceRequest;
